export const PRELIM_NOTICE_TITLE = "Prelim Notice";

export const PRELIM_NOTICE_FIRST_PARAGRAPH =
  "Pursuant to NJ law, the criminal report has been either redacted from view or not processed and the applicant was not asked about criminal history as part of their rental application.";

export const PRELIM_NOTICE_SECOND_PARAGRAPH =
  "In order to view/process the criminal report, you must preliminarily notify the applicant that he/she/they are approved/conditionally approved pending the results of their criminal background report results and/or completion of a secondary application. Have you provided or do you wish to send this preliminary approval notice?";
